import EmptyState from "@/components/EmptyState/EmptyState"
import Pill from "@/components/Pill/Pill"
import { PAINS_COPY } from "@/content/pains"
import { useSessionStore } from "@/store/sessionStore"
import { painsBy, selectCurrentDoneKey, selectPains, selectSession } from "@/store/selectors"
import styles from "@/styles/pages/Pains.module.css"

/*
 * Who is still writing, for the facilitator only. Counts, never text — if the
 * watcher could read the notes as they appeared, the room would converge on the
 * first one, which is the failure the round is designed around.
 *
 * It rides in the rail under `FacilitatorPanel`, like `PickMonitor`: a roster of
 * the room belongs beside the facilitator's script, not in the column the room
 * is writing in. Mounted by `Session` because the rail is the shell's.
 */
export default function PainsMonitor() {
  const session = useSessionStore(selectSession)
  const pains = useSessionStore(selectPains)
  const participants = useSessionStore((s) => s.participants)
  const doneKey = useSessionStore(selectCurrentDoneKey)

  if (!session) return null

  const limit = session.config.painsPerParticipant

  return (
    <section className={styles.roster}>
      <h2 className={styles.rosterTitle}>{PAINS_COPY.watchTitle}</h2>

      {participants.length === 0 ? (
        <EmptyState title={PAINS_COPY.emptyBoard} />
      ) : (
        <ul className={styles.rosterRows}>
          {participants.map((participant) => {
            const written = painsBy(pains, participant.id).length
            const finished = participant.donePhase === doneKey
            return (
              <li key={participant.id} className={styles.rosterRow}>
                <span className={styles.rosterName}>{participant.name}</span>
                <span className={styles.rosterCount}>{PAINS_COPY.brief(written, limit)}</span>
                <Pill tone={finished ? "done" : "warning"} dot pulse={!finished}>
                  {finished ? PAINS_COPY.stateDone : PAINS_COPY.stateWriting}
                </Pill>
              </li>
            )
          })}
        </ul>
      )}
    </section>
  )
}
